import styled from "styled-components";

export const Container = styled.main`
    display: flex;
    flex-direction: column;
    margin-top: 75px;
    padding: 0 10px;
    width: 100%;
    @media (min-width: 720px) {
        margin: 40px 0 0 200px;
    }
    @media (orientation: landscape) and (max-width: 1080px){
        margin-left: 25px;
    }
`;

export const Title = styled.h1`
    color: #333;
    font-size: 32px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    text-align: center;
    width: 100%;
`;

export const TitleContainer = styled.div`
    align-self: flex-start;
    display: flex;
    justify-content: center;
    padding-block: 20px;
    width: 100%;
    @media (min-width: 720px) {
        width: 90%;
    }
`;

export const ContainerRow = styled.form`
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-top: 20px;
    width: 100%;
    @media (min-width: 1100px) {
        align-items: flex-start;
        flex-direction: row;
        justify-content: flex-start;
    }
`;

export const ContainerColumn = styled.div`
    align-items: center;
    display: flex;
    flex-direction: column;
    gap: 15px;
    justify-content: flex-start;
    padding: 20px;
    width: 80%;
    @media (min-width: 1100px) {
        width: 30%;
    }
`;

export const ImageIcon = styled.img`
    height: 24px;
    width: 24px;
`;

export const ButtonsContainer = styled.div`
    display: flex;
    gap: 25px;
    justify-content: center;
    padding-bottom: 150px;
    width: 100%;
    @media (min-width: 1100px) {
        align-self: flex-end;
        justify-content: space-between;
        margin-right: 10%;
        padding: 20px;
        width: 30%;
    }
`;

export const ContainerCheckbox = styled.form`
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-top: 20px;
`;

export const RowContainer = styled.div`
    align-items: center;
    display: flex;
    gap: 18px;
    justify-content: center;
`;